import React from "react";
import "./EmptyResult.scss";
import PropTypes from "prop-types";

const EmptyResult = ({ content }) => <div className="emptyContent">{content}</div>;
EmptyResult.propTypes = { content: PropTypes.string.isRequired };
export default EmptyResult;
